import {FC} from "react";
import {KCTEventDto, OrganizationAdminDto} from "../../types/contracts";

interface OrganizationsTableProps {
    organizations: OrganizationAdminDto[];
    events: KCTEventDto[] | null;
    isLoading: boolean;
    selectedValue: string;
}

const OrganizationsTable: FC<OrganizationsTableProps> = ({organizations, events, isLoading, selectedValue}) => {
    let content;

    if (events === null || selectedValue === '') {
        content = <div className="text-center">Nejprve vyberte akci.</div>;
    } else if (isLoading && organizations.length === 0) {
        content = <div className="text-center">Načítám data organizací...</div>;
    } else if (organizations.length === 0) {
        content = <div className="text-center">Žádné přihlášené organizace na tuto akci.</div>;
    } else {
        content = (
            <table className="min-w-full border-collapse whitespace-nowrap bg-white border border-black">
                <thead>
                <tr className="">
                    <th className="py-2 px-1 border">Název organizace</th>
                    <th className="py-2 px-1 border">Jméno vedoucího</th>
                    <th className="py-2 px-1 border">Příjmení vedoucího</th>
                    <th className="py-2 px-1 border">Adresa organizace</th>
                    <th className="py-2 px-1 border">Email</th>
                    <th className="py-2 px-1 border">Tel. číslo</th>
                    <th className="py-2 px-1 border">Datum objednávky</th>
                    <th className="py-2 px-1 border">Počet účastníků</th>
                </tr>
                </thead>
                <tbody>
                {organizations.map((organization, index) => (
                    <tr key={index} className="text-center bg-white hover:bg-gray-200 hover:cursor-default">
                        <td className="py-2 px-1 border">{organization.name}</td>
                        <td className="py-2 px-1 border">{organization.leaderName}</td>
                        <td className="py-2 px-1 border">{organization.leaderLastname}</td>
                        <td className="py-2 px-1 border">{organization.address}</td>
                        <td className="py-2 px-1 border">{organization.email}</td>
                        <td className="py-2 px-1 border">{organization.phoneNumber}</td>
                        <td className="py-2 px-1 border">{organization.orderDate}</td>
                        <td className="py-2 px-1 border">{organization.participantsCount}</td>
                    </tr>
                ))}
                </tbody>
            </table>
        );
    }

    return content;
};

export default OrganizationsTable;
